import { booleanAttribute, ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { cueDirections, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { DialogRef } from '@angular/cdk/dialog';
import { NavigationService } from '@cue/navigation-services';
import { rxResource } from '@angular/core/rxjs-interop';
import { LoadingComponent } from '@cue/loading';
@Component({
  selector: 'cue-open-in-navigation-button',
  imports: [IconComponent, TranslocoPipe, LoadingComponent],
  templateUrl: './open-in-navigation-button.component.html',
  styleUrl: './open-in-navigation-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpenInNavigationButtonComponent {
  navigationService = inject(NavigationService);
  resourceId = input.required<number>();

  enabled = input.required<boolean, boolean>({
    transform: booleanAttribute,
  });

  navigationAppUrl = input.required<string>();

  router = inject(Router);
  ICONS = {
    cueDirections,
  };
  protected readonly translation = translation;
  modalToClose = input<DialogRef<unknown, unknown>>();

  data = rxResource({
    params: () => (this.resourceId() ? this.resourceId() : undefined),
    stream: ({ params }) => {
      return this.navigationService.getNavigationDetail({
        resourceId: this.resourceId(),
        appId: null,
        kioskId: null,
      });
    },
  });

  available = computed(() => {
    return this.enabled() && this.data.hasValue() && this.data.value()?.qrCodes.length > 0;
  });

  onOpenInNavigation() {
    if (this.modalToClose()) {
      this.modalToClose().close();
    }
    const url =
      location.origin + '/navigation?areaId=' + this.data.value().areaId + '&openedResourceId=' + this.resourceId();
    window.open(url, '_blank');
  }
}
